import { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useForwardedRef, useMeasure } from '@adsk/alloy-react-helpers';
import { LEFT_PADDING, RIGHT_PADDING } from '../consts';
import { firefoxNumberInputWorkaround, getIsFirefox } from '../helpers';
export default (_ref => {
  let {
    type,
    renderLeft,
    renderRight,
    onKeyDown,
    ref,
    showCount,
    softLimit,
    maxLength,
    showCountThreshold,
    onChange,
    value,
    defaultValue
  } = _ref;
  const inputRef = useForwardedRef(ref || null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const [charCount, setCharCount] = useState(0);
  const {
    width: leftWidth
  } = useMeasure(leftRef);
  const {
    width: rightWidth
  } = useMeasure(rightRef);
  useLayoutEffect(() => {
    if (renderLeft) {
      if (leftWidth && inputRef.current) {
        const newPadding = LEFT_PADDING + leftWidth + 5;
        inputRef.current.style.paddingLeft = `${newPadding}px`;
      }
    }
  }, [inputRef, renderLeft, leftWidth]);
  useLayoutEffect(() => {
    if (value !== undefined && value !== null) {
      setCharCount(value.length);
    }
  }, [value]);
  useLayoutEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      setCharCount(defaultValue.toString().length);
    }
    // we only want to do this on mount since it's the default value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleKeyDown = useCallback(event => {
    if (getIsFirefox() && type === 'number') {
      firefoxNumberInputWorkaround({
        event,
        inputRef
      });
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  }, [inputRef, onKeyDown, type]);
  const shouldRenderCount = useMemo(() => {
    const limit = showCount !== false && (softLimit || maxLength);
    return limit && (!showCountThreshold || showCountThreshold && limit - charCount <= showCountThreshold);
  }, [showCount, maxLength, softLimit, charCount, showCountThreshold]);
  useLayoutEffect(() => {
    if (renderRight || shouldRenderCount) {
      let width = rightWidth;

      // this is to handle cases where rightRef.current has mutated and
      // useMeasure does not know about it
      if (!width) {
        width = 0;
        if (rightRef !== null && rightRef !== void 0 && rightRef.current) {
          var _getBoundingClientRec;
          width = (_getBoundingClientRec = rightRef.current.getBoundingClientRect()) === null || _getBoundingClientRec === void 0 ? void 0 : _getBoundingClientRec.width;
        }
      }
      if (width && inputRef.current) {
        const newPadding = RIGHT_PADDING + width + 8;
        inputRef.current.style.paddingRight = `${newPadding}px`;
      }
    } else if (inputRef.current) {
      inputRef.current.style.paddingRight = `${RIGHT_PADDING + 8}px`;
    }
  }, [inputRef, renderRight, shouldRenderCount, rightWidth]);
  const handleChange = useCallback(event => {
    if (value === undefined || value === null) {
      if (event.target.value) {
        setCharCount(event.target.value.length);
      } else {
        setCharCount(0);
      }
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }, [onChange, value]);
  const getInputProps = useCallback(() => {
    return {
      ref: inputRef,
      type,
      onKeyDown: handleKeyDown,
      onChange: handleChange,
      dir: 'auto',
      value,
      defaultValue
    };
  }, [handleKeyDown, inputRef, type, handleChange, value, defaultValue]);
  return {
    refs: {
      leftRef,
      rightRef
    },
    propGetters: {
      getInputProps
    },
    charCount,
    shouldRenderCount
  };
});
//# sourceMappingURL=useTextInput.js.map